<!-- 数据详情弹窗 -->
<template>
  <el-dialog
    width="960px"
    title="批量添加节目"
    :before-close="handleClose"
    :visible.sync="dialogVisible"
    showClose
    append-to-body
    center
  >
    <cs-form
      ref="ruleForm"
      label-width="90px"
      form-width="100%"
      :form="form"
      :formData="searchData"
      :form-col="searchFormCol"
      :inline="true"
      class="header-search-box"
    >
      <template slot="updateTimeArr">
        <el-date-picker
          @change="formChange"
          v-model="updateTimeArr"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </template>
      <template slot="search">
        <el-button type="primary" @click="search">查询</el-button>
      </template>
    </cs-form>
    <cs-table
      ref="tableProgram"
      :tableCols="tableCols"
      :tableData="tableData"
      :paginationOption="programPageOption"
      @size-change="sizeChangeHandler"
      @current-change="currentPageHandler"
      @selection-change="selectionChange"
    >
      <template slot-scope="scope" slot="updateTime">{{scope.row.updateTime|timeFormat}}</template>
    </cs-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="goClearSelection()">取消</el-button>
      <el-button type="primary" @click="handleSubmitAdd()">添加</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { fetchSndCategory } from '@/resource/api/index'
import { programs, bindOrUnbind } from '../../../resource/api/program-group-management'
import cpMixin from '@/views/mixins/cp.js'
import ugcMixin from '@/views/mixins/ugc.js'
import vodMixin from '@/views/mixins/vod.js'
export default {
  mixins: (() => {
    switch (process.env.VUE_APP_NODE_ENV) {
      case 'CP':
        return [cpMixin]
      case 'UGC' :
        return [ugcMixin]
      case 'VOD':
        return [vodMixin]
      default:
        return [cpMixin]
    }
  })(),
  props: {
    programSetId: {
      type: String,
      required: true
    },
    category: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      sndObj: {},
      dialogVisible: false,
      updateTimeArr: [],
      form: {
        name: '',
        category: '',
        sndCategory: '',
        startTime: '',
        endTime: '',
        timeFlag: 'updateTime',
        isSingleProgram: 1,
        isBatch: 1,
        limit: 20,
        offset: 1
      },
      searchFormCol: { gutter: 10, sm: 12, md: 8, lg: 6 },
      tableData: [],
      programPageOption: {}, // 节目集发布分页参数
      multipleSelection: [], // 节目集批量选中
      insideData: {},
      categoryList: [],
      sndCategoryList: [] // 二级分类
    }
  },
  computed: {
    envType () {
      return process.env.VUE_APP_NODE_ENV
    }
  },
  methods: {
    open () {
      this.dialogVisible = true
      this.form.category = this.category
      this.$nextTick(() => {
        // 等待dom同步后打开模态框
        this.$refs.ruleForm.resetFields()
        this.pageInit()
      })
    },
    // 初始化
    pageInit () {
      if (process.env.VUE_APP_NODE_ENV == 'VOD') {
        this.form.operator = this.$store.state.router.createBySuffix
      } else {
        this.form.operator = this.$store.state.router.createBy
      }
      this.programPageOption['page-size'] = this.$store.state.pageLimit
      this.form = {
        ...this.form,
        limit: this.$store.state.pageLimit
      }
      // this.tableData = []
      this.getCategoryList()
      this.search()
    },
    // 加载数据
    getData (data) {
      const that = this
      programs(data).then((res) => {
        if (res.code == 1 && res.results) {
          that.tableData = res.results
          this.programPageOption = {
            ...this.programPageOption,
            'current-page': this.form.offset,
            total: parseInt(res.total)
          }
        }
      })
    },
    formChange (timeArr) {
      if (timeArr === null) {
        this.form.startTime = ''
        this.form.endTime = ''
      } else {
        this.form.startTime = timeArr[0]
        this.form.endTime = timeArr[1]
      }
    },
    // 查询
    search (val) {
      this.form = {
        ...this.form,
        offset: 1,
        limit: this.$store.state.pageLimit
      }
      this.currentPageHandler(1)
    },
    // 取消选中
    goClearSelection () {
      this.$emit('refreshhMethod')
      this.dialogVisible = false
    },
    // 批量添加
    handleSubmitAdd () {
      const that = this
      if (that.multipleSelection.length == 0) {
        that.$message('还没有选中内容')
      } else if (that.multipleSelection.length > 0) {
        const data = {
          bindOrUnbindFlag: '批量加入',
          programSetId: that.programSetId,
          programIds: that.multipleSelection,
          updateBy: ''
        }
        if (process.env.VUE_APP_NODE_ENV == 'VOD') {
          data.updateBy = that.$store.state.router.updateBySuffix
        } else {
          data.updateBy = that.$store.state.router.updateBy
        }
        bindOrUnbind(data).then((res) => {
          if (res.code == 1) {
            that.$message({
              message: '添加成功',
              type: 'success'
            })
            that.currentPageHandler(1)
          } else if (res.code == 0) {
            that.$message({
              message: res.msg,
              type: 'error'
            })
            that.currentPageHandler(1)
          }
        }).catch(() => {})
      }
    },
    // 获取选中数据
    selectionChange (selection) {
      this.multipleSelection = selection.map(item => item.id)
    },
    sizeChangeHandler (val) {
      this.form.limit = val
      this.form.offset = 1
      this.getData(this.form)
    },
    currentPageHandler (val) {
      this.form.offset = val
      this.getData(this.form)
    },
    handleClose (done) {
      this.$emit('refreshhMethod')
      this.dialogVisible = false
    },
    // 获取二级分类
    selectChangeCategory (val) {
      this.form.sndCategory = ''
      this.sndCategoryList = this.sndObj[val]
    },
    // 获取一级分类菜单
    // 获取分类下拉框内容
    getCategoryList: function () {
      var that = this
      that.categoryList = []
      fetchSndCategory().then((res) => {
        if (res.code == 1) {
          const data = res.result
          if (this.envType != 'CP') {
            that.categoryList.push({
              value: '',
              label: '全部'
            })
          }
          data.forEach(item => {
            that.categoryList.push({
              value: item.category,
              label: item.category
            })
            if (this.envType != 'CP') {
              that.sndObj[item.category] = [{ value: '', label: '全部' }]
            } else {
              that.sndObj[item.category] = []
            }
            const arr = item.sndCategory
            arr.forEach(itemIn => {
              that.sndObj[item.category].push({
                value: itemIn,
                label: itemIn
              })
            })
          })
          that.sndCategoryList = that.sndObj[that.form.category]
        }
      })
    }
  }
}
</script>
<style></style>
